import { Box, Typography } from '@mui/material';
import { AlarmConditionItem } from 'src/features/alarms/components/alarm-condition-item';

import { ClearingInfo } from 'src/types/alarms';
import { formatSecondsToDhms, formatUTCDateToLocal } from 'src/utilities';

import {
  titleStyle,
  conditionsBox,
  StyledConditionItem,
  StyledConditionItemColumn,
} from '../style';
import { LiveDataAlarmConditionRowItem } from '../liveDataAlarmConditionRowItem/LiveDataAlarmConditionRowItem';

type Props = {
  clearingInfo: ClearingInfo;
  testId: string;
};

export const LiveDataAlarmClearingInfo = ({ clearingInfo, testId }: Props) => (
  <Box sx={{ marginTop: '8px' }}>
    <StyledConditionItem>
      <StyledConditionItemColumn>
        <Typography data-sm="Clear Conditions" sx={titleStyle}>
          Clear Conditions
        </Typography>
        <Box sx={conditionsBox} data-sm={testId}>
          {clearingInfo.clearingConditions?.map((condition, i: number) => {
            const isExtendedRow = i > 0;
            return (
              <AlarmConditionItem
                key={condition.inputId}
                isExtendedRow={isExtendedRow}
                condition={condition}
              />
            );
          })}
        </Box>
      </StyledConditionItemColumn>
      <StyledConditionItemColumn>
        {clearingInfo.clearingDelay !== undefined && (
          <LiveDataAlarmConditionRowItem
            description="Clear Delay"
            value={formatSecondsToDhms(clearingInfo.clearingDelay)}
            testId="clear-delay"
          />
        )}
        {clearingInfo.clearedAt && (
          <LiveDataAlarmConditionRowItem
            description="Cleared At"
            value={formatUTCDateToLocal(false, clearingInfo.clearedAt)}
            testId="cleared-at"
          />
        )}
      </StyledConditionItemColumn>
    </StyledConditionItem>

    {clearingInfo.reason && (
      <Box>
        <Typography sx={{ fontSize: '14px' }}>{clearingInfo.reason}</Typography>
      </Box>
    )}
  </Box>
);
